import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { PushNotification } from '@shared/ui';

interface IFileNotificationsPushProps {
    fileNames: string[];
    currentFolderName: string;
    isOpenPushNotification: boolean;
    isAwaitingUpload: boolean;
    isUploading: boolean;
    isFetchingFiles: boolean;
    isErrorUploading: boolean;
    setIsAwaitingUpload: React.Dispatch<React.SetStateAction<boolean>>;
    setIsOpenPushNotification: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FileNotificationsPush = ({
    fileNames,
    currentFolderName,
    isOpenPushNotification,
    isAwaitingUpload,
    isUploading,
    isFetchingFiles,
    isErrorUploading,
    setIsAwaitingUpload,
    setIsOpenPushNotification,
}: IFileNotificationsPushProps) => {
    const { t } = useTranslation();
    useEffect(() => {
        if (isAwaitingUpload && !isErrorUploading && !isUploading && !isFetchingFiles) {
            setIsOpenPushNotification(true);
            setIsAwaitingUpload(false);
        }
    }, [
        isAwaitingUpload,
        setIsAwaitingUpload,
        setIsOpenPushNotification,
        isErrorUploading,
        isUploading,
        isFetchingFiles,
    ]);

    useEffect(() => {
        let timeout = null;
        if (isOpenPushNotification) {
            timeout = setTimeout(() => {
                setIsOpenPushNotification(false);
            }, 5000);
        }

        return () => clearTimeout(timeout);
    }, [isOpenPushNotification, setIsOpenPushNotification]);
    return (
        <PushNotification
            isOpen={isOpenPushNotification}
            textContent={`${
                fileNames.length > 1
                    ? t('Files.FileNotificationsPush.fileText.plural')
                    : t('Files.FileNotificationsPush.fileText.one')
            } ${fileNames.join(', ')} ${
                fileNames.length > 1
                    ? t('Files.FileNotificationsPush.fileText.were')
                    : t('Files.FileNotificationsPush.fileText.was')
            } ${t('Files.FileNotificationsPush.fileText.success')} ${
                fileNames.length > 1
                    ? t('Files.FileNotificationsPush.fileText.download.plural')
                    : t('Files.FileNotificationsPush.fileText.download.one')
            } ${t('Files.FileNotificationsPush.fileText.inFolder')} ${currentFolderName}`}
        />
    );
};
